import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import SignupContainer from './SignupContainer';

const SignupPageContainer = () => {
  const navigate = useNavigate();

  const onSuccess = useCallback(() => {
    navigate('/dashboard/cards');
  }, [navigate]);

  return (
    <SignupContainer onSuccess={onSuccess} />
  );
};

SignupPageContainer.displayName = 'SignupPageContainer';

export default SignupPageContainer;
